<template>
	<div class="report-wrap">
		<main class="eval-main">
			<section class="eval-items-wrap">
				<dl class="eval-item">
					<dt class="blind">사유</dt>
					<dd>
						<span
							v-for="item in items"
							:key="item.code"
							class="gui-radio invert large"
						>
							<input
								type="radio"
								:id="'d_' + item.code"
								:value="item.code"
								v-model="code"
							/>
							<label :for="'d_' + item.code"><i></i>{{ item.val }}</label>
						</span>
					</dd>
				</dl>

				<dl class="eval-write" v-show="code === '9'">
					<dt class="eval-question">신고 사유를 적어주세요.</dt>
					<div class="gui-input-field">
						<div class="label-wrap">
							<aside class="words-len top">
								<em class="cnt">{{ content.length }}</em> / <span class="total">500</span>
							</aside>
						</div>
						<div class="gui-input lg">
							<textarea
								id="declr-write"
								v-model="content"
								rows="3"
								maxlength="500"
							></textarea>
						</div>
					</div>
				</dl>

				<div class="notification-block">
					<i class="gis-info_circle_fill sm"></i>
					<div class="desc-wrap">
						<p class="desc-md">신고하신 내용은 관리자 검토 후 내부 정책에 따라 조치됩니다.</p>
					</div>
				</div>

				<div class="btns-wrap">
					<button
						class="gui-btn big accent"
						:class="{ disabled: disableFlag }"
						@click="submit()"
					>
						<span>신고하기</span>
					</button>
				</div>
			</section>
		</main>
	</div>
</template>

<script>
import { APP_URL } from "../api/index";
import store from "@/store";

export default {
	name: "Report",
	data() {
		return {
			item: store.state,
			items: store.state.reportOption,
			code: "",
			content: "",
		};
	},
	computed: {
		disableFlag() {
			return this.code === "" || (this.code === "9" && this.content.length < 1);
		},
	},
	watch: {
		code(val) {
			if (val !== "9") this.content = "";
		},
	},
	methods: {
		async submit() {
			if ("Y" == this.item.loginYn || "Y" == this.item.detail.loginYn) {
				if ("" == this.code) {
					alert("신고사유를 입력해주세요");
				} else if (this.code === "9" && this.content.length < 1) {
					alert("사유를 입력해주세요");
				} else {
					try {
						const check = await axios.get(
							APP_URL + "/knownew/estimate/productReviewReportCheck.gs",
							{
								params: { prdrevwId: this.$route.params.messageId },
								withCredentials: true,
							}
						);

						if (!!check.data && !!check.data.errorFlg) {
							alert(check.data.errorMsg);
							return;
						}

						const formData = new FormData();
						formData.append("prdrevwId", this.$route.params.messageId);
						formData.append("declrTyp", this.code);
						formData.append("declrRsn", this.content);

						const response = await axios.post(
							APP_URL + "/knownew/estimate/productRevwReportProcess.gs",
							formData,
							{ withCredentials: true }
						);

						const reportResultMsg =
							response.data.procFlg == "Y"
								? response.data.procMsg
								: "잠시 후 다시 시도해주세요.";
						alert(reportResultMsg);
						history.back();
					} catch (error) {
						console.log(error);
						alert("오류가 발생했습니다. 다시 시도해주세요.");
					}
				}
			} else {
				var loginUrl =
					APP_URL +
					"/member/logIn.gs?returnurl=" +
					location.origin +
					"/list/" +
					this.$route.params.prdcd;
				if ("Y" == store.state.appYn) {
					loginUrl = "toapp://login?param=" + location.href;
				}
				location.href = loginUrl;
			}
		},
	},
};
</script>

<style scoped>
@font-face {
	font-family: 'gsicons';
	src: url('https://public.m-gs.kr/ui/gsshop/fonts/gsicons.ttf?s8lazs') format('truetype'),
	     url('https://public.m-gs.kr/ui/gsshop/fonts/gsicons.woff?s8lazs') format('woff'),
	     url('https://public.m-gs.kr/ui/gsshop/fonts/gsicons.svg?s8lazs#gsicons') format('svg');
	font-weight: normal;
	font-style: normal;
	font-display: block;
}

[class^="gis-"], [class*=" gis-"] {
	font-family: 'gsicons' !important;
	speak: never;
	font-style: normal;
	font-weight: normal;
	font-variant: normal;
	text-transform: none;
	line-height: 1;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

.gis-info_circle_fill:before {
	content: "\ea4d";
	color: var(--semantic-primary-default);
}

*, *::before, *::after {
	box-sizing: border-box;
}

/* 접근성 숨김 */
.blind {
	position: absolute;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	width: 1px;
	height: 1px;
	margin: -1px;
	padding: 0;
	border: 0;
	white-space: nowrap;
}

/* CSS 변수 */
.report-wrap {
	--semantic-primary-default: #0F78FF;
	--semantic-secondary-default: #FF2F93;
	--border-primary: #D2D4E5;
}

/* ===== 레이아웃 ===== */
.report-wrap {
	max-width: 600px;
	margin: 0 auto;
}
.eval-main {
	padding: 20px 16px;
}
.eval-item, .eval-write {
	padding-bottom: 20px;
}

/* ===== 라디오 (gui-radio) ===== */
.gui-radio {
	display: flex;
	align-items: center;
	padding: 8px 0;
	position: relative;
	user-select: none;
	font-size: 14px;
	color: #191923;
	cursor: pointer;
}
.gui-radio [type='radio'] {
	position: absolute;
	opacity: 0;
	width: 0;
	height: 0;
}
.gui-radio label {
	display: flex;
	align-items: center;
	gap: 8px;
	cursor: pointer;
	width: 100%;
}
.gui-radio i {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	width: 22px;
	height: 22px;
	border-radius: 50%;
	border: 1.5px solid #9595B2;
	background-color: #fff;
	font-style: normal;
}
.gui-radio.large i {
	width: 26px;
	height: 26px;
}
.gui-radio i::after {
	content: '';
	width: 12px;
	height: 12px;
	border-radius: 50%;
	background-color: #D2D4E5;
	transform: scale(0);
	transition: transform 0.2s ease-in-out, background-color 0.2s ease-in-out;
}
.gui-radio.large i::after {
	width: 16px;
	height: 16px;
}
.gui-radio input:checked + label i {
	border-color: var(--semantic-primary-default);
}
.gui-radio input:checked + label i::after {
	transform: scale(1);
	background-color: var(--semantic-primary-default);
}

/* ===== 기타 사유 입력 ===== */
.eval-question {
	margin-bottom: 10px;
	font-size: 16px;
	font-weight: 600;
	color: #191923;
}
.gui-input-field {
	display: flex;
	flex-direction: column;
}
.label-wrap {
	display: flex;
	justify-content: flex-end;
}
.words-len {
	margin-bottom: 4px;
	line-height: 16px;
	font-size: 11px;
	color: #9595B2;
}
.words-len .cnt {
	font-style: normal;
}
.gui-input {
	position: relative;
	border-radius: 8px;
	font-size: 16px;
}
.gui-input::before {
	content: "";
	display: flex;
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	border: 1px solid var(--border-primary);
	border-radius: inherit;
	pointer-events: none;
}
.gui-input textarea {
	width: 100%;
	padding: 10px 16px;
	border: none;
	border-radius: inherit;
	background: transparent;
	line-height: 1.5;
	resize: none;
	font-size: 14px;
	color: #191923;
	min-height: 84px;
	outline: none;
	font-family: inherit;
}

/* ===== 안내 문구 ===== */
.notification-block {
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 12px 16px;
	border-radius: 12px;
	background-color: #F5F6FA;
	color: #76768E;
	margin: 0 0 20px;
	font-size: 13px;
	line-height: 1.4;
}
.notification-block .desc-wrap {
	flex: 1;
}
.notification-block .desc-md {
	margin: 0;
}

/* ===== 등록하기 버튼 ===== */
.btns-wrap {
	display: flex;
	padding: 8px 0;
}
.gui-btn {
	box-sizing: border-box;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex: 1;
	height: 3rem;
	padding: 10px 16px;
	border-radius: 8px;
	border: none;
	text-align: center;
	font-size: 16px;
	transition: all 0.2s ease-in-out;
	user-select: none;
	cursor: pointer;
	font-family: inherit;
}
.gui-btn span {
	white-space: nowrap;
}
.gui-btn.red {
	background-color: var(--semantic-secondary-default);
	color: #fff;
}
.gui-btn.red:not(.disabled):active {
	background-color: #fb0079;
}
.gui-btn.accent {
	background-color: var(--semantic-primary-default) !important;
	color: #fff !important;
}
.gui-btn.accent:not(.disabled):active {
	background-color: #0060cc !important;
}
.gui-btn.disabled {
	color: #BABAD4;
	background-color: rgba(92, 92, 112, 0.08);
	cursor: default;
}
</style>
